export const protoTimestampToMs = (timestamp: { seconds: string | number | bigint; nanos?: number }): number => {
  const seconds = typeof timestamp.seconds === 'bigint' ? Number(timestamp.seconds) : Number(timestamp.seconds)
  const nanos = timestamp.nanos ?? 0
  return seconds * 1000 + Math.floor(nanos / 1_000_000)
}

export const formatDate = (timestamp: number, showTime = true, locale = 'ru'): string => {
  const date = new Date(timestamp)
  const isRu = locale === 'ru' || locale === 'ru-RU'
  const dateStr = date.toLocaleDateString(isRu ? 'ru-RU' : 'en-US')
  if (!showTime) return dateStr

  const timeStr = date.toLocaleTimeString(isRu ? 'ru-RU' : 'en-US', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return isRu ? `${dateStr} в ${timeStr}` : `${dateStr} at ${timeStr}`
}
